var React = require('react');

function RenewalCrossed (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.2549 4.62812V0.75L8.23435 5.59765L13.2549 10.4453V6.56718C16.5784 6.56718 19.2795 9.17522 19.2795 12.3844C19.2795 13.4386 18.988 14.428 18.4787 15.2813L19.938 16.6904C20.7906 15.4587 21.2877 13.9778 21.2877 12.3844C21.2877 8.09904 17.693 4.62812 13.2549 4.62812ZM16.9578 19.2698L21.08 23.25L22.5 21.8789L2.92001 2.97306L1.5 4.34418L15.4414 17.8056C14.7633 18.0612 14.0258 18.2015 13.2549 18.2015C9.93128 18.2015 7.23025 15.5935 7.23025 12.3844H5.22205C5.22205 16.6697 8.81673 20.1406 13.2549 20.1406C14.5906 20.1406 15.8499 19.8262 16.9578 19.2698Z","fill":"currentColor"}));
}

RenewalCrossed.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = RenewalCrossed;

RenewalCrossed.default = RenewalCrossed;
